import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const testimonials = [
  {
    name: "Sarah L.",
    role: "Product Manager, SaaSFlow",
    quote: "CyborgSapient transformed our user experience. The turnaround time was incredible, and the designs boosted our conversions significantly!",
  },
  {
    name: "David M.",
    role: "Founder, StartupX",
    quote: "The team is exceptionally responsive and creative. Unlimited revisions really meant we could perfect every single detail.",
  },
  {
    name: "Aisha R.",
    role: "CMO, MarketDash",
    quote: "Their strategy-oriented approach and eye for detail made a measurable impact on our growth campaigns.",
  },
];

const Testimonial = () => {
  return (
    <section className="py-16 sm:py-20 px-6 sm:px-8 lg:px-12 bg-gradient-to-br from-purple-50/30 via-pink-50/30 to-blue-50/30 min-h-screen flex items-center">
      <div className="max-w-6xl mx-auto w-full">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-light text-gray-900 mb-4 tracking-tight">
            <span className="font-semibold">Testimonials</span>
          </h2>
          <p className="text-xl font-light text-gray-600 max-w-2xl mx-auto">
            What our clients say about working with us
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6 mb-12">
          {testimonials.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="bg-white border border-gray-200 rounded-2xl p-6 hover:shadow-lg transition-shadow duration-300"
            >
              <p className="text-gray-900 text-lg mb-8 leading-relaxed">
                "{item.quote}"
              </p>
              <div className="border-t border-gray-200 pt-6">
                <h4 className="text-lg font-semibold text-gray-900 mb-1">{item.name}</h4>
                <p className="text-gray-600 text-sm">{item.role}</p>
              </div>
            </motion.div>
          ))}
        </div>

        {/* CTA Section */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="text-center bg-white border border-gray-200 rounded-3xl p-12"
        >
          <h3 className="text-3xl sm:text-4xl font-light text-gray-900 mb-6 tracking-tight">
            Ready to become our<br />
            <span className="font-semibold">next success story?</span>
          </h3>
          <Link
            to="/contact"
            className="inline-block text-lg px-10 py-4 bg-gradient-to-r from-orange-300 via-pink-300 to-purple-300 text-white rounded-full font-medium hover:opacity-90 transition-opacity duration-200 shadow-lg"
          >
            Work With Us
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default Testimonial;
